<template>
  <section class="data-profile">
    <v-container grid-list-xl fluid>
      <v-layout>
        <v-flex xs4>
          <user-avatar />
          <upload-avatar />
        </v-flex>

        <v-flex xs8>
          <v-layout wrap>
            <v-flex md12>
              <strong class="headline">{{user.reduced_name}}</strong>
              <v-chip disabled>{{user.username}}</v-chip>
            </v-flex>

            <v-flex md6>
              <v-btn
                flat
                small>
                <v-icon left>mdi-email-outline</v-icon>
                {{user.email}}
              </v-btn>
            </v-flex>

            <!-- atualizar senha não está funcionando -->
            <!-- <v-flex md6>
              <dialog-update-password />
            </v-flex> -->
          </v-layout>

          <v-divider />

          <v-layout column>
            <v-subheader style="width: 100%;">
              Assinatura Digitalizada
              <v-btn
                small
                flat
                color="accent"
                v-if="user.signature.url"
                @click="toggleModalSignature(true)">
                Alterar
              </v-btn>
            </v-subheader>

            <user-signature v-if="user.signature.url" />
            <upload-signature v-if="!user.signature.url" />
            <modal-signature />
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import UserAvatar from '@/components/account/avatar/UserAvatar';
import UploadAvatar from '@/components/account/avatar/UploadAvatar';
import UserSignature from '@/components/account/signature/UserSignature';
import UploadSignature from '@/components/account/signature/UploadSignature';
import DialogUpdatePassword from '@/components/authentication/password/update/DialogUpdatePassword';
import ModalSignature from '@/components/account/signature/ModalSignature';

export default {
  name: 'DataAccount',
  components: {
    DialogUpdatePassword,
    ModalSignature,
    UserAvatar,
    UploadAvatar,
    UserSignature,
    UploadSignature,
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    modalSignature() {
      return this.$store.getters.modalSignature;
    },
  },
  methods: {
    toggleModalSignature(value) {
      this.$store.dispatch('toggleModalSignature', value);
    },
    imageuploaded(res) {
      if (res.errcode === 0) {
        this.src = res.data.src;
      }
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/account/profile/DataAccount.vue